import React, { useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';

const CustomLaneMenu = ({ onDeleteLane, onCopyLane, onSortLane, onDownloadForm, forms, ...args }) => {
  const [showInput, setShowInput] = useState(false);
  const [newLaneName, setNewLaneName] = useState('');
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [showFormsMenu, setShowFormsMenu] = useState(false);
  const [formsMenuAnchorEl, setFormsMenuAnchorEl] = useState(null);

  const handleCopyClick = () => {
    setMenuAnchorEl(null);
    setShowInput(true);
  };

  const handleInputChange = (e) => setNewLaneName(e.target.value);

  const handleCopySubmit = () => {
    if (newLaneName.trim() !== '') {
      onCopyLane(args.id, newLaneName);
      setNewLaneName('');
      setShowInput(false);
    }
  };

  return (
    <div style={{ position: 'relative' }}>
      <IconButton
        aria-label="more"
        onClick={(event) => setMenuAnchorEl(event.currentTarget)}
        size='small'
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="organization-menu"
        anchorEl={menuAnchorEl}
        keepMounted
        open={Boolean(menuAnchorEl)}
        onClose={() => setMenuAnchorEl(null)}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <MenuItem
          key={'sort'}
          value={'sort'}
          onClick={() => {
            setMenuAnchorEl(null);
            onSortLane(args.id);
          }}
        >
          規劃路線
        </MenuItem>
        <MenuItem
          key={'copy'}
          value={'copy'}
          onClick={handleCopyClick}
        >
          複製群組
        </MenuItem>
        <MenuItem
          key={'delete'}
          value={'delete'}
          onClick={() => {
            setMenuAnchorEl(null);
            if (window.confirm('確定要刪除此群組嗎？')) {
              onDeleteLane(args.id);
            }
          }}
        >
          刪除群組
        </MenuItem>
        <MenuItem
          key="download-forms"
          value="download-forms"
          onClick={(e) => {
            setFormsMenuAnchorEl(e.currentTarget);
            setShowFormsMenu((prev) => !prev);
          }}
          disabled={!forms || forms.length === 0}
        >
          下載表單
          <KeyboardArrowRightIcon style={{ marginLeft: 'auto' }} />
        </MenuItem>
        <Menu
          id="forms-menu"
          anchorEl={formsMenuAnchorEl}
          keepMounted
          open={Boolean(showFormsMenu)}
          onClose={() => setShowFormsMenu(false)}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {forms.map((form) => (
            <MenuItem
              key={form.id}
              value={form.id}
              onClick={() => {
                setShowFormsMenu(false);
                onDownloadForm(args.id, form);
              }}
            >
              {form.name}
            </MenuItem>
          ))}
        </Menu>
      </Menu>
      {showInput && (
        <div style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          backgroundColor: 'white',
          boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
          borderRadius: '4px',
          zIndex: 1000,
          padding: '10px',
          width: '200px',
        }}>
          <input
            type="text"
            value={newLaneName}
            onChange={handleInputChange}
            placeholder="請輸入新群組名稱"
            style={{
              width: '100%',
              padding: '8px',
              borderRadius: '4px',
              marginBottom: '8px',
              border: '1px solid #ccc',
            }}
          />
          <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '8px' }}>
            <Button
              onClick={() => {
                setShowInput(false);
                setNewLaneName('');
              }}
              color="default"
            >
              取消
            </Button>
            <Button onClick={handleCopySubmit} color="primary" variant="contained"
              disabled={newLaneName.trim() === ''}
            >
              確定
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

CustomLaneMenu.propTypes = {
  onDeleteLane: PropTypes.func.isRequired,
  onCopyLane: PropTypes.func.isRequired,
  onSortLane: PropTypes.func.isRequired,
  onDownloadForm: PropTypes.func.isRequired,
  forms: PropTypes.array,
};


export default CustomLaneMenu;
